<template>
  <div class="row mb-1">
    <div
      id="topik-by-source"
      class="col-md-12 px-gap"
    >
      <div class="card card-default shade">
        <div class="card-body">
          <div class="row">
            <div class="col-md-12 col-sm-12">
              <div class="pull-left m-t-5 m-b-5">
                <h4 class="m-b-0">
                  Grafik Topik Berdasarkan Sumber
                </h4>
                <p class="small hint-text">
                  Grafik Topik Berdasarkan Sumber
                </p>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12"> 
              <div
                v-if="bar_data.x.length === 0"
                class="alert alert-danger"
                id="errorApiEl"
                role="alert"
                align="center"
              >
                <strong>Mohon maaf, data tidak tersedia! </strong>
                <br>
                Tidak dapat menampilkan grafik dengan data kosong.
              </div>
              <bar-chart-component
                v-else
                :data="bar_data"
                :reversed="reversed"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import bar_chart_horizontal from "@/views/components/chart/bar_chart_horizontal.vue";

export default {
  name: "TopikBySource",
  props: {
    data: {
      type: Object,
      default: function () {
        return null;
      },
    },
    tipe: String,
  },
  components: {
    "bar-chart-component": bar_chart_horizontal,
  },
  data() {
    return {
      bar_data: {
        x: [],
        y: [],
      },
      reversed: false,
    };
  },
  methods: {
    assembleBarData() {
      let color = [];
      let name = [];
      if (this.tipe == "medkon") {
        this.reversed = true;
        color = ["", "", "#f16528"];
      } else {
        this.reversed = false;
        color = [
          "#1da1f2",
          "#4267b2",
          "#e1306c",
          "#dc3545",
          "#000000",
          "#ffc107",
          "#3f3f3f",
        ];
      }
      if (this.tipe == "medkon") {
        name = ["", "", "Media Online"];
      } else {
        name = [
          "Twitter",
          "Facebook",
          "Instagram",
          "Youtube",
          "Forum",
          "Blog",
          "Tinjauan Aplikasi",
          "Tiktok",
        ];
      }
      if (this.data.series && this.data.category) {
        this.bar_data.source = this.data.source
        this.bar_data.x = this.data.category;
        for (let i = 0; i < this.data.series.length; i++) {
          if (this.tipe == "medkon") {
            if (this.data.series[i].name == 'news') {
              this.bar_data.y[i] = {
                color: color[i],
                name: name[i],
                data: this.data.series[i].data,
              };
            }
          } else {
            if (this.data.series[i].name != 'blog' && this.data.series[i].name != 'review') {
              this.bar_data.y[i] = {
                color: color[i],
                name: name[i],
                data: this.data.series[i].data,
              };
            }
          }
        }
      }
    },
  },
  created() {
    if (this.data) {
      this.assembleBarData();
    }
  },
};
</script>